import React from 'react';
import EmailComposer from '../EmailComposer';

export default function SendEmail() {
  return <EmailComposer />;
}
